import React from "react";
import { RoomMovie } from "../../../api/room";
import RoomMovieCard from "./RoomMovieCard";
import styles from "./RoomMovieCards.module.scss";

interface RoomMovieCardsProps {
  movies: RoomMovie[];
  onMovieClick: (index: number) => void;
}

const RoomMovieCards: React.FC<RoomMovieCardsProps> = ({ movies, onMovieClick }) => {
  if (!movies.length) return null;

  return (
    <div className={styles.cardsColumn}>
      {movies.slice(0, 3).map((movie, idx) => (
        <RoomMovieCard
          key={movie.id}
          movie={movie}
          onClick={() => onMovieClick(idx)}
        />
      ))}
    </div>
  );
};

export default RoomMovieCards;
